import React, {FC, useState} from "react"

import {getMessage, useIntl} from "@irati/utils/lang"
import magicLoginService from "@irati/auth/services/magicLogin"
import {getErrorMessage, getErrorValues} from "@irati/utils/lang/formatError"
import {CreateMagicLoginResponse} from "@irati/types"
import magicLoginCodes from "@irati/auth/errorCodes/Magic"

import EnterEmail from "./EnterEmail"
import ConfirmCode from "./ConfirmCode"
import OneTimePasswordBackground from "../../components/OneTimePasswordBackground"

enum Screens {
  enterEmail = "enterEmail",
  confirmCode = "confirmCode"
}

const OneTimePassword: FC = () => {
  const [screen, setScreen] = useState(Screens.enterEmail)
  const [identifier, setIdentifier] = useState("")
  const [magicLogin, setMagicLogin] = useState<CreateMagicLoginResponse>()
  const [load, setLoad] = useState<Promise<any> | null>(null)
  const [showAlert, setShowAlert] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")

  const {formatMessage} = useIntl()

  const handleActivation = (email: string) => {
    setErrorMsg("")
    if (email) {
      setShowAlert(false)
      setIdentifier(email)
      sendOTPCode(email)
    }
  }

  const handleGoBack = () => {
    setShowAlert(false)
    setIdentifier("")
    setScreen(Screens.enterEmail)
  }

  const sendOTPCode = (email: string) => {
    const loaded = magicLoginService
      .createMagicLogin(email)
      .then((res) => {
        setShowAlert(true)
        setMagicLogin(res)
        setScreen(Screens.confirmCode)
      })
      .catch((err) => {
        setShowAlert(false)
        setScreen(Screens.enterEmail)

        const isErrorUnknownEmail = err?.networkError?.errorCode === magicLoginCodes.MagicBadRequest && screen === Screens.enterEmail
        const message = isErrorUnknownEmail
          ? formatMessage({id: "errors.magic.PBMagicUnexpected"})
          : getMessage(formatMessage, getErrorMessage(err), getErrorValues(err))
        setErrorMsg(message)
      })
    setLoad(loaded)
  }

  const handleResendCode = () => {
    setShowAlert(false)
    sendOTPCode(identifier)
  }

  return (
    <OneTimePasswordBackground showAlert={showAlert} onHideAlert={() => setShowAlert(false)}>
      {screen === Screens.enterEmail && <EnterEmail load={load} onClick={handleActivation} error={errorMsg} />}
      {screen === Screens.confirmCode && (
        <ConfirmCode
          login={magicLogin}
          email={identifier}
          goBack={handleGoBack}
          onResend={handleResendCode}
          hideAlert={() => setShowAlert(false)}
        />
      )}
    </OneTimePasswordBackground>
  )
}

export default OneTimePassword
